module.exports = __webpack_public_path__ + "img/memberIcon.f6dac55e.svg";